var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8049_227972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4215 16.5311H10.2064L11.5919 7.58368H13.8068L12.4215 16.5311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4514 7.80274C20.0145 7.6217 19.3215 7.42181 18.4647 7.42181C16.2773 7.42181 14.7369 8.64012 14.7274 10.3819C14.7093 11.667 15.8303 12.3808 16.6687 12.8093C17.5257 13.2472 17.817 13.533 17.817 13.9233C17.8083 14.5227 17.1245 14.799 16.4868 14.799C15.6025 14.799 15.1286 14.6565 14.4085 14.323L14.1168 14.1801L13.8069 16.1886C14.3264 16.4358 15.2835 16.6552 16.2773 16.6648C18.6014 16.6648 20.1145 15.4653 20.1325 13.6091C20.1413 12.5906 19.5494 11.8101 18.2732 11.1724C17.4985 10.763 17.024 10.4869 17.024 10.0681C17.0331 9.68726 17.4253 9.29723 18.2998 9.29723C19.0199 9.27812 19.549 9.45891 19.9498 9.63982L20.1501 9.73483L20.4514 7.80274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.395 13.3614C23.5775 12.8473 24.2794 10.8579 24.2794 10.8579C24.2702 10.877 24.4614 10.3344 24.5708 10.0013L24.7256 10.7723C24.7256 10.7723 25.1451 12.914 25.2362 13.3614C24.89 13.3614 23.8326 13.3614 23.395 13.3614ZM26.1292 7.58368H24.4159C23.8875 7.58368 23.4861 7.74536 23.2582 8.32605L19.968 16.531H22.2922C22.2922 16.531 22.6748 15.4267 22.7571 15.1888C23.012 15.1888 25.273 15.1888 25.601 15.1888C25.6646 15.5029 25.8653 16.531 25.8653 16.531H27.9162L26.1292 7.58368Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35654 7.58368L6.1873 13.685L5.95025 12.4476C5.5492 11.0197 4.29143 9.46845 2.88782 8.69711L4.87477 16.5216H7.21711L10.6988 7.58368H8.35654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17287 7.58368H0.609091L0.572632 7.76446C3.3526 8.50696 5.19372 10.2967 5.95015 12.4479L5.17543 8.33579C5.04788 7.76434 4.65592 7.60253 4.17287 7.58368Z",
    fill: "#A8ACB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8049_227972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.3438,
    height: 9.24296,
    fill: "white",
    transform: "translate(0.572632 7.42188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.3f1a790de0113f157d3854e5eb844d33.svg";
export { ForwardRef as ReactComponent };